import * as actionTypes from '../actions/actionTypes'

const initialState = {
  gamesPlayed: [],
  loading: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_GAMES_PLAYED:
      return {
        ...state, 
        gamesPlayed: action.gamesPlayed
      }
    case actionTypes.FETCH_GAMES_START:
      return {
        ...state,
        loading: true
      }
    case actionTypes.FETCH_GAMES_SUCCESS:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}

export default reducer